import { CSSObject } from '@chakra-ui/react';
import { RaceCardSchema } from './RaceCards.styles';

export const raceCardStyles: RaceCardSchema = {
  GridRaceCards: {
    my: '2',
    mb: '3',
    fontFamily: 'accent',
  },
  FlexCard: {
    my: '1',
    borderRadius: 'lg',
    bg: 'rgba(0, 209, 255, 0.25)',
    boxShadow:
      '0px 0px 0px 1px rgba(255, 255, 255, 0.2) inset,  0px 4px 6px 0px rgba(0, 0, 0, 0.15)',
  },
  LinkCardHeader: {
    bg: 'transparent',
    color: 'beta.400',
  },
  TextCardHeading: {
    color: 'white',
    fontSize: 'sm',
    fontWeight: 'semibold',
    textShadow: '0px 3px 4px rgba(0, 0, 0, 0.25)',
  },
  TextRaceNumber: {
    bg: 'gray.300',
    borderRadius: 'sm',
    color: 'gray.600',
    boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
  },
  GridCardContent: {
    color: 'blackAlpha.400',
    fontSize: 'sm',
    p: '0',
  },
  BoxGridHeaderItem: {
    bg: 'blackAlpha.400',
    color: 'white',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    lineHeight: 'normal',
  },
  FlexGridRunnerItem: {
    bg: 'transparent',
    borderBottom: '1px dashed',
    borderBottomColor: 'blackAlpha.300',
    px: '2.5',
  },
  TextRunner: {
    fontSize: 'xs',
    color: 'white',
    fontWeight: 'bold',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
  },
  TextRunnerNumber: {
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
    sx: {
      _last: {
        fontSize: '2xs',
        fontWeight: 'normal',
        pos: 'relative',
        top: '-2px',
      },
    },
  },
  TextScratched: {
    color: 'white',
  },
  LinkRaceDetails: {
    color: 'beta.600',
    bgGradient: 'linear(180deg, beta.300 0%, beta.400 100%)',
    border: '2px solid',
    borderColor: 'transparent',
    boxShadow:
      '0px 0px 0px 1px rgba(92, 68, 19, 1) inset, 0px 2px 1px 0px rgba(255, 255, 255, 0.5) inset, 0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    textShadow: '0px 1px 0px rgba(255, 255, 255, 0.35)',
    position: 'relative',
    m: '2',
    py: '2',
    borderRadius: 'md',
    fontFamily: 'accent',
    fontSize: 'xs',
    fontWeight: 'bold',
    textTransform: 'capitalize',
    transition: 'all .2s ease-in-out',
    _hover: {
      bgGradient: 'linear(180deg, beta.300 0%, beta.400 100%)',
      color: 'beta.700',
    },
    _disabled: {
      opacity: 0.4,
      pointerEvents: 'none',
      boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    },
  },
  buttonRaceCardOddsProps: {
    w: '100%',
    fontSize: '15px',
    variant: 'odds',
    h: '8',
  },
};

export const TextRunner: CSSObject = {
  color: 'white',
};

export const IconCardHeader: CSSObject = {
  color: '#FFD27B',
};
